module.exports = __webpack_public_path__ + "static/img/lAHPBbCc24iO-9dAQA_64_64.0021828.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/lAHPBbCc24iO-9dAQA_64_64.gif
// module id = iTsb
// module chunks = 1